<template>
	<div>
		<NavBer></NavBer>
		<Title></Title>

		<div class="w contents">
			<div class="jianjie">
				公司介绍
			</div>
			<el-row>
				<el-col :span="16">
					<div class="grid-content">
						<el-carousel :interval="4000" type="card" height="350px" indicator-position="none">
							<el-carousel-item v-for="(item, index) in Rotation" :key="index">
								<div class="chart">
									<router-link to="/overview"> <img :src="item.url" alt=""/></router-link>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="grid-content">
						<div style="padding: 10px 20px; font-size: 20px; font-weight: bold; text-align: center;">河北杏林医药物流有限公司</div>
						<!-- <div style="padding: 0 20px;">简称：迈德润大药房</div> -->
						
						<div class="" style="padding: 10px; ">
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								河北杏林医药物流有限公司以“诚信、专业、创新、共赢”为核心价值观，秉承“呵护健康，传递温暖”的企业使命，致力于打造高效、安全的医药供应链体系。我们坚持客户至上、团队协作、责任担当，以优质服务推动医药行业高质量发展，为社会健康事业贡献力量。
							</div>
						</div>
						<!-- <div class="" style="padding: 10px; font-size: 12px;">
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								河北杏林医药物流有限公司是河北省一家具有药品现代物流资质的医药企业，公司位于河北省石家庄市高新区太行西街113号，公司依托先进的智能化仓储系统和高效的配送网络，为医药生产、流通及终端客户提供安全、合规、精准的医药物流服务。</div
							>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								公司成立于2024年10月22日，获得河北省药品监督管理局批准的药品现代物流企业资质，符合《河北省药品现代物流指导意见》标准。公司经营范围涵盖药品、医疗器械、中药饮片代煎服务、保健食品、预包装食品、消毒剂、日用品、信息咨询、健康咨询、等等。</div
							>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								公司以“质量第一；用户至上；创造价值；贡献社会”为经营总方针；以“诚信守法经营；严格规范管理；坚持质量第一；竭诚服务客户”为质量方针，依托先进的第三方医药物流配送平台，发展B2B业务（对接医疗机构、药店），可自建电商平台或与互联网医疗平台合作，构建“医+药+物流”闭环生态。未来，公司将持续优化服务，助力医药行业高质量发展，为守护人民健康贡献力量。</div
							>
						</div> -->
					</div>
				</el-col>
			</el-row>
			<!-- <div class="jianjie">
        公司服务
      </div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content">
            <router-link class="dongtai" to="/dynamic">
            <div>
              <img src="../assets/images/index/index04.jpg" alt="">
            </div>
            </router-link>
          </div>
          
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <router-link class="dongtai" to="/dynamic">
            <div>
              <img src="../assets/images/index/index05.jpg" alt="">
            </div>
            </router-link>
          </div>
          
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <router-link class="dongtai" to="/dynamic">
            <div>
              <img src="../assets/images/index/index07.jpg" alt="">
            </div>
            </router-link>
          </div>
          
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <router-link class="dongtai" to="/dynamic">
            <div>
              <img src="../assets/images/index/index08.jpg" alt="">
            </div>
            </router-link>
          </div>
          
        </el-col>
      </el-row> -->
			<!-- <div class="jianjie">
        新闻资讯
      </div>
      <el-row>
        <el-col :span="8" class="newss">
          <div class="grid-content">
            <div class="xinwen">
              <img src="../assets/images/news/xinwen01.jpg" alt="">
            </div>
            <div>
              <span>2021-10-10</span>
              <router-link to="/news">开幕仪式</router-link>
            </div>
          </div>
        </el-col>
        <el-col :span="8" class="newss">
          <div class="grid-content">
            <div class="xinwen">
              <img src="../assets/images/news/xinwen02.jpg" alt="">
            </div>
            <div>
              <span>2021-10-10</span>
              <router-link to="/news">梵净山健心欢乐之旅《健心中国行》</router-link>
            </div>
          </div>
        </el-col>
        <el-col :span="8" class="newss">
          <div class="grid-content">
            <div class="xinwen">
              <img src="../assets/images/news/xinwen03.jpg" alt="">
            </div>
            <div>
              <span>2021-10-10</span>
              <router-link to="/news">开拓创新 团结奋进 </router-link>
            </div>
          </div>
        </el-col>
      </el-row> -->
		</div>

		<Footbar></Footbar>
	</div>
</template>

<script>
import NavBer from "../components/nav";
import Title from "../components/title";
import Footbar from "../components/footbar";
export default {
	components: {
		NavBer,
		Title,
		Footbar,
	},
	data() {
		return {
			Rotation: [
				
				{
					url: require("../assets/images/index/index09.jpg"),
				},
				{
					url: require("../assets/images/index/index10.jpg"),
				},
				{
					url: require("../assets/images/index/index01.jpg"),
				},
				{
					url: require("../assets/images/index/index02.jpg"),
				},
				{
					url: require("../assets/images/index/index03.jpg"),
				},
				{
					url: require("../assets/images/index/index07.jpg"),
				},
				{
					url: require("../assets/images/index/index08.jpg"),
				}
				
			],
		};
	},
};
</script>

<style scoped>
.contents {
	margin-top: 60px;
}
.jianjie {
	width: 100px;
	text-align: center;
	margin: 60px auto 40px;
	font-size: 20px;
	border-bottom: 1px solid #333;
}

.el-row {
	margin-bottom: 20px;
}
.el-col {
	border-radius: 4px;
}

.grid-content {
	border-radius: 4px;
	min-height: 350px;
	overflow: hidden;
	box-shadow: 0px 27px 46px 0px rgba(0, 0, 0, 0.15);
}
.grid-content p {
	width: 240px;
	margin: 80px auto;
}
.chart img {
	height: 350px;
	width: 100%;
}
.dongtai img {
	width: 100%;
	height: 400px;
}

.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 350px;
	margin: 0;
}
.newss {
	padding: 10px;
}
.xinwen img {
	width: 100%;
	height: 240px;
	margin-bottom: 20px;
}
.newss span {
	margin: 0 20px 0 20px;
	font-size: 14px;
	color: #666;
}

.newss a:hover {
	color: #02b2b5;
}
</style>
